import { addMonths, isAfter, isBefore, parseISO, startOfDay } from 'date-fns'
import { isEmpty } from 'util/checks'

export const isDataAgendamentoInvalida = (data: string, serverTime: Date) =>
  isEmpty(data) || isAfter(parseISO(data), addMonths(serverTime, 6)) || isBefore(parseISO(data), startOfDay(serverTime))
